import React from 'react';
import { cx } from 'linaria';
import { theme } from '../../../Theme';
import { styled } from 'linaria/react';

const FakeCTAWrapper = styled('div')`
  font-size: 14px;
  font-weight: bold;
  border-radius: 0;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 43px;
  line-height: 1.2;
  padding: 0 24px;
  font-family: 'Figtree', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  transition: all, 0.2s ease;
  width: fit-content;

  &.black {
    background: ${theme.colors.black};
    color: ${theme.colors.white};

    &:hover {
      background: ${theme.colors.darkgrey};
    }
  }

  &.primary {
    background: ${theme.colors.accent};
    color: ${theme.colors.white};

    &:hover {
      background: ${theme.colors.lightgreen};
    }

    &.ghost {
      background: transparent;
      border: 1px solid ${theme.colors.accent};
      color: ${theme.colors.accent};

      &:hover {
        background: ${theme.colors.accent + '1A'};
      }
    }
  }

  &.light {
    background: ${theme.colors.white};
    color: ${theme.colors.black};

    &:hover {
      background: ${theme.colors.white + 'E0'};
    }

    &.ghost {
      background: transparent;
      border: 1px solid ${theme.colors.white};
      color: ${theme.colors.white};
      &:hover {
        background: ${theme.colors.white + '1A'};
      }
    }
  }

  &:active {
    animation: enhanceButton 0.3s ease-in-out;
  }

  @keyframes enhanceButton {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.02);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const FakeCTA = ({ className, children }) => {
  return (
    <FakeCTAWrapper className={cx(className, 'fake-cta')}>
      {children}
    </FakeCTAWrapper>
  );
};
